import React, { useState, useEffect } from "react";
import {attributesToProps, domToReact} from 'html-react-parser'
import uuidv4 from 'uuid/v4'


const Toggler = ({node, options}) => {
  const props = attributesToProps(node.attribs);

  const [ref, setRef] = useState(null);

  useEffect(() => {
    if(ref == null) return;

    const toggleVisibility = () => {
      const oldClasses = $(ref).attr("class")
      $("[group=" + props.group + "]").not(ref).each((i, el) => {
        $(el).removeClass(props["toggle-class"]).addClass(oldClasses)
      })
      $(ref).removeClass(oldClasses).addClass(props["toggle-class"])

      if(props.effect == "slide") {
        $(props.untoggles).slideUp()
        $(props.untoggles).promise().done(() => $(props.toggles).slideDown())
      } else {
        $(props.untoggles).fadeOut()
        $(props.untoggles).promise().done(() => $(props.toggles).fadeIn())
      }
    };

    $(ref).off("click").on("click", toggleVisibility);

    return () => {
      $(ref).off("click")
    };
  }, [ref]);

  return <div {...props} ref={setRef}>
    {domToReact(node.children, options)}
  </div>;
}


export default Toggler
